import { Dosis } from './dosis';

export class Vacuna {
    id: number;
    orden: string;
    fecha: string;
    nombre: string;
    listadosis: Dosis[];
}



// WEBPACK FOOTER //
// ./src/models/vacuna.ts